import { DEFAULT_PERSO_MARGIN_MIN, persoConflicts } from '@ergo/shared';
import { api } from '../api';
import { useResource } from '../hooks';
import { conflictLabel, persoOfDay, usePersoEvents } from '../perso';
import { isValidDate, isValidTime } from '../time';

export interface PersoWarningProps {
  date: string;
  time: string;
  durationMin: number;
}

/**
 * Un mot quand le créneau tombe sur — ou tout près d'— un rendez-vous perso. Comme
 * les avertissements de faisabilité : informatif, jamais bloquant, c'est elle qui
 * décide (DESIGN.md). Rien à afficher tant qu'aucun agenda n'est configuré.
 */
export function PersoWarning({ date, time, durationMin }: PersoWarningProps) {
  const valid = isValidDate(date) && isValidTime(time);
  const events = usePersoEvents(valid ? date : '', valid ? date : '');
  const settings = useResource(() => api.settings.get(), []);
  if (!valid) return null;

  const conflicts = persoConflicts(
    { startsAt: `${date}T${time}`, durationMin },
    persoOfDay(events, date).timed,
    settings.data?.persoMarginMin ?? DEFAULT_PERSO_MARGIN_MIN,
  );
  if (conflicts.length === 0) return null;

  return (
    <div role="status">
      {conflicts.map((conflict) => (
        <p className="note-sun" key={conflict.event.uid}>
          {conflictLabel(conflict)}
        </p>
      ))}
    </div>
  );
}
